import {animate, motion, useMotionValue} from "framer-motion";
import {JSX} from "react";

type Feature = {
    title: string;
    description: string;
    icon: JSX.Element;
    colorClass?: string;
};

type TiltCardProps = {
    feature: Feature;
    index: number;
};

// Пример родительских вариантов:
// - hidden: исходное состояние (для анимации появления)
// - show: конечное состояние при скролле (whileInView)
// - hover: состояние ховера
const cardVariants = {
    hidden: { opacity: 0, y: 20 },
    show: { opacity: 1, y: 0 },
    hover: {},
};

// Варианты для иконки:
// - В состоянии "hover" она масштабируется на 1.15
const iconVariants = {
    hidden: { scale: 1 },
    show: { scale: 1 },
    hover: {
        scale: 1.15,
        transition: { type: "spring", stiffness: 200 },
    },
};

export function SmallCard({ feature, index }: TiltCardProps) {
    // Framer Motion значения для углов поворота (3D-tilt)
    const rotateX = useMotionValue(0);
    const rotateY = useMotionValue(0);

    // Обработчик движения мыши — вычисляем наклон
    function handleMouseMove(e: React.MouseEvent<HTMLDivElement, MouseEvent>) {
        const { left, top, width, height } = e.currentTarget.getBoundingClientRect();
        const x = e.clientX - left;
        const y = e.clientY - top;

        const centerX = width / 2;
        const centerY = height / 2;
        const multiplier = 20; // Чем больше, тем сильнее наклон

        const newRotateY = ((x - centerX) / centerX) * multiplier;
        const newRotateX = -((y - centerY) / centerY) * multiplier;

        rotateX.set(newRotateX);
        rotateY.set(newRotateY);
    }

    // Плавный сброс наклона при уходе курсора
    function handleMouseLeave() {
        animate(rotateX, 0, { duration: 0.3 });
        animate(rotateY, 0, { duration: 0.3 });
    }

    return (
        <motion.div
            className="bg-gray-500 p-6 rounded-lg shadow-lg flex flex-col items-center text-center"
            // Используем variants
            variants={cardVariants}
            initial="hidden"
            whileInView="show"
            whileHover="hover" // при наведении => состояние hover
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: index * 0.1 }}

            // Стиль, позволяющий 3D-вращение
            style={{
                perspective: 1000,
                rotateX: rotateX,
                rotateY: rotateY,
                transformStyle: "preserve-3d",
            }}

            onMouseMove={handleMouseMove}
            onMouseLeave={handleMouseLeave}
        >
            {/* Иконка, которая подхватывает состояние hover от родителя */}
            <motion.div
                className={`mx-auto mb-4 ${feature.colorClass}`}
                variants={iconVariants}
            >
                {/*{feature.icon}*/}
            </motion.div>

            <h3 className="text-2xl font-inter text-white">{feature.title}</h3>
            <p className="mt-2 text-gray-300">{feature.description}</p>
        </motion.div>
    );
}
